import { useContext } from 'react'
import { AppTabsContext } from '.'

export const useAppTabs = () => {
  const appTabsContext = useContext(AppTabsContext)
  return appTabsContext
}
